import Text from '@cartwhl/ui/base/TextNew';
import Button from '@cartwhl/ui/input/Button';

export interface DashboardWorkListErrorProps {
  message?: string;
  onRetry: () => void;
}

export default function DashboardWorkListError({
  message,
  onRetry,
}: DashboardWorkListErrorProps) {
  return (
    <div className="mx-auto flex w-full max-w-[1020px] items-center justify-between gap-4 px-2">
      <Text token="14/medium" className="text-secondary text-pretty">
        {message || 'Failed to load recent work.'}
      </Text>
      <Button type="button" variant="secondary" size="sm" onClick={onRetry}>
        Retry
      </Button>
    </div>
  );
}
